import script from "./rightline.vue?vue&type=script&setup=true&lang=js"
export * from "./rightline.vue?vue&type=script&setup=true&lang=js"

import "./rightline.vue?vue&type=style&index=0&id=0ef27a89&scoped=true&lang=css"
script.__scopeId = "data-v-0ef27a89"

export default script